export type DataStructureTabId = "gl" | "gpx" | "date-ranges" | "primary-fields";

export const VALID_DATA_STRUCTURE_TABS: readonly DataStructureTabId[] = [
  "gl",
  "gpx",
  "date-ranges",
  "primary-fields",
];

export type PackageTab = "hierarchy" | "formulas" | "queries";

export const VALID_PACKAGE_TABS: readonly PackageTab[] = ["hierarchy", "formulas", "queries"];

export type ViewFilter = "active" | "archived";

export const VALID_VIEW_FILTERS: readonly ViewFilter[] = ["active", "archived"];

export const VIEW_FILTER_OPTIONS: { label: string; value: ViewFilter }[] = [
  { label: "Active", value: "active" },
  { label: "Archived", value: "archived" },
];

export type DataPackage = {
  id: number;
  arenaId: number | null;
  name: string;
  description: string;
  hierarchy: string;
  formulas: number;
  queries: number;
  usage: number | null;
  lastUpdated: string;
  updatedByFullName: string | null;
  archivedAt: string | null;
  archivedByFullName: string | null;
  isDefault: boolean;
};
